module.exports = __webpack_public_path__ + "img/idigi-merac-logo.120c9ff1.png";